import React, { useEffect, useState } from 'react';
import Popup from 'reactjs-popup';
import { LoadingStatus } from '../../../../contexts/ford-rides-context/ford-rides-context';
import { ActivityIndicator } from '../../../common/activity-indicator/activity-indicator';
import './rides-loader.scss';
import { FMButton } from '@own/fds-react';

interface LoaderData {
    moreTimeTimeOut?: number;
    moreTimeMessage?: string;
    moreTimeCancelCtaText?: string;
}

interface Props {
    loadStatus: LoadingStatus;
    abortController: AbortController | null;
    loaderData: LoaderData;
}

const RidesLoader = (props: Props) => {
    const [showAbortButton, setShowAbortButton] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    useEffect(() => {
        if (
            props.loaderData.moreTimeTimeOut &&
            props.loaderData.moreTimeCancelCtaText
        ) {
            const timerId = setTimeout(() => {
                setShowAbortButton(true);
            }, props.loaderData.moreTimeTimeOut);
            return () => {
                clearTimeout(timerId);
                setShowAbortButton(false);
            };
        }
    }, [props.abortController]);

    useEffect(() => {
        if (
            [LoadingStatus.IndividualLoad, LoadingStatus.InitialLoad].includes(
                props?.loadStatus
            )
        ) {
            setOpenModal(true);
        } else {
            setOpenModal(false);
        }
    }, [props.loadStatus]);

    return (
        <Popup
            open={openModal}
            modal={true}
            lockScroll={true}
            className="ford-rides-loader"
            closeOnDocumentClick={false}
        >
            <div className="loader-content">
                <ActivityIndicator />
                {LoadingStatus.IndividualLoad === props.loadStatus &&
                showAbortButton &&
                props.abortController ? (
                    <>
                        {props.loaderData.moreTimeMessage ? (
                            <p className="slow-network-text">
                                {props.loaderData.moreTimeMessage}
                            </p>
                        ) : null}
                        <FMButton
                            onClick={() => props.abortController?.abort()}
                            type="primary"
                            label={props.loaderData.moreTimeCancelCtaText}
                        />
                    </>
                ) : (
                    <></>
                )}
            </div>
        </Popup>
    );
};

export default RidesLoader;
